import MeetingLaunchpad from './views/MeetingLaunchpad.vue';
import SingleMeeting from './views/SingleMeeting.vue';

const routes = [
  {
    name: 'meetings',
    path: '/advisor/meetings',
    component: MeetingLaunchpad,
  },
  {
    name: 'meeting',
    path: '/advisor/meetings/:meetingId',
    component: SingleMeeting,
    props: route => ({
      meetingIdQueryParam: route.query.meetingId,
    }),

  },
];

export default routes;
